import React, { useEffect, useState } from 'react';
import CancelSvg from 'assets/icons/modal-close.svg';
import { Button, Input } from 'components/common';
import EthSvg from 'assets/icons/priceIcon.svg';
import { useMakeBid, useMarketplace, useListing } from '@thirdweb-dev/react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { useToast } from '../Toast/ToastProvider';

interface AddFeatureProps {
  showModal: boolean;
  setShowModal: any;
  property: any;
}

const BidOnPropertyModal = ({
  showModal,
  setShowModal,
  property,
}: AddFeatureProps) => {
  const marketplace = useMarketplace(
    process.env.REACT_APP_MARKETPLACE_ADDRESS // Your marketplace contract address here
  );

  const {
    data: listing,
    isLoading,
    error,
  } = useListing(marketplace, property.listingId);

  const toast = useToast();

  const PriceSchema = Yup.object().shape({
    price: Yup.number().required().positive(),
  });

  const SubmitBid = async (price: any) => {
    // setShowModal(false);
    const bid = await marketplace?.auction.makeBid(property.listingId, price);
    console.log(bid?.receipt, bid);

    toast?.success('Bid submitted successfully');
    setShowModal(false);
  };

  return (
    <>
      {showModal ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative my-6 mx-auto w-[36rem] max-w-xl">
              <div className="bg-gray-4 border-0 rounded-lg shadow-lg relative flex flex-col w-full outline-none focus:outline-none">
                <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                  <h3 className="text-white text-2xl font-semibold">
                    Place your bid on {property.title}
                  </h3>
                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black  float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => setShowModal(false)}
                  >
                    <img src={CancelSvg} alt="close-modal" />
                  </button>
                </div>

                <Formik
                  initialValues={{
                    price: '',
                  }}
                  validationSchema={PriceSchema}
                  onSubmit={(values, actions) => {
                    console.log(values, actions);
                    SubmitBid(values.price);
                  }}
                >
                  {(props) => {
                    const {
                      values,
                      errors,
                      isSubmitting,
                      touched,
                      setFieldValue,
                    } = props || {};
                    return (
                      <Form>
                        <div className="relative p-6 flex-auto">
                          <div className="grid grid-cols-3">
                            <div className="">
                              <p className="text-white opacity-70">
                                Minimum bid price :{' '}
                              </p>
                            </div>
                            <div className="col-span-2 flex">
                              <img
                                src={EthSvg}
                                alt="eth-price"
                                className="mr-2"
                              />
                              <p className="text-white">
                                {property.price} <small>(750,000 USDC)</small>{' '}
                              </p>
                            </div>
                          </div>
                          <div className="grid grid-cols-3 mt-4">
                            <div className="">
                              <p className="text-white opacity-70">
                                Enter bid price :{' '}
                              </p>
                            </div>
                            <div className="col-span-2 flex">
                              <img
                                src={EthSvg}
                                alt="eth-price"
                                className="mr-2"
                              />
                              <Input
                                name="price"
                                value={values.price}
                                error={values.price}
                                type="number"
                                className="bg-transparent border border-white px-2 py-1 rounded text-white outline-none appearance-none hover:appearance-none"
                              />
                              <p className="text-white ml-2">
                                <small>(750,000 USDC)</small>{' '}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="flex items-center justify-between p-6 border-t border-solid border-slate-200 rounded-b">
                          <div className="">
                            <p className="text-white">Note:</p>
                            <p>
                              <small className="text-white">
                                Once a bid is made, it cannot be withdrawn.
                              </small>
                            </p>
                            <p>
                              <small className="text-white">
                                Bids must be higher than either the reserve
                                price, OR if there is an existing bid, it must
                                be higher than the current bid by 5%
                              </small>
                            </p>
                            <p>
                              <small className="text-white">
                                The previous highest bid is refunded
                                automatically when a higher bid is made.
                              </small>
                            </p>
                          </div>
                          <button
                            className="bg-primary-2 text-white active:bg-primary-3 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                            type="submit"
                          >
                            Place bid
                          </button>
                        </div>
                      </Form>
                    );
                  }}
                </Formik>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black" />
        </>
      ) : null}
    </>
  );
};

export default BidOnPropertyModal;
